import { PermissionLevels } from '../../constants/assignment-permissions'

const assignmentSelectors = {
    id: state => state.assignment.assignment?.assignment_id,
    name: state => state.assignment.assignment?.assignment_name,
    type: state => state.assignment.assignment?.assignment_type,
    submissionType: state => state.assignment.assignment?.submission_type,
    language: state => state.assignment.assignment?.language,
    isFetching: state => state.assignment.isWaitingForAssignmentInfo,
    hideGrading: state => Boolean(state.assignment.assignment?.hide_grading),
    showGenerateSimilarSubmissionsModal: state => state.assignmentSlice.showGenerateSimilarSubmissionsModal,
    showProgressDrawer: state => state.assignmentSlice.showProgressDrawer,
    showCreateMbaModal: state => state.assignmentSlice.showCreateMbaModal,
    modelHasMba: state => state.assignment.assignment?.current_version?.has_mba,
    confirmChangesMode: state => state.assignment.confirmChangesMode,
    showQueryEditor: state => state.assignment.drawer.showQueryEditor,
    processingStatus: state => state.assignment.assignment?.current_version?.processing_status,
    processingProgress: state => state.assignment.assignment?.current_version?.processing_progress,
    processingMessage: state => state.assignment.assignment?.current_version?.processing_msg,
    accessType: state => state.assignment.assignment?.access_type,
    permissionLevel: state => state.assignment.assignment?.permission_level,
    isOwner: state => state.assignment.assignment?.permission_level === PermissionLevels.OWNER,
    ownerId: state => state.assignment.assignment?.user_id,
    ownerName: state => state.assignment.assignment?.user_name,
    hasMbas: state => state.assignment.assignment?.has_mba,
    serverAssignmentLastModified: state => state.assignmentSlice.serverAssignmentLastModified,
    clientAssignmentLastModified: state => state.assignmentSlice.clientAssignmentLastModified,
    reviewFilter: state => state.assignment.filters.review,
    queryComparisonMode: state => state.assignment.queryComparisonMode,
    hasUnitTests: state => state.assignment.assignment?.current_version?.has_ut || false,
    trialExpired: state => state.assignment.assignment?.is_trial_valid === false,
    lmsSubmissionsImported: state => state.assignment.assignment?.lms_submissions_imported,
    lmsSubmissionsExported: state => state.assignment.assignment?.lms_grades_sent,
    lmsCourseId: state => state.assignment.assignment?.lms_course_id,
    lmsQuizId: state => state.assignment.assignment?.lms_quiz_id,
    lmsEnabled: state => state.assignment.assignment?.lms_enabled,
    startDate: state => state.assignment.assignment?.start_date,
    endDate: state => state.assignment.assignment?.end_date,
    workloadDistribution: state => state.assignment.assignment.workload_distribution,
    description: state => state.assignment.assignment?.description,
    disciplines: state => state.assignment.assignment?.disciplines,
    timeToSolve: state => state.assignment.assignment?.time_to_solve,
    difficultyLevel: state => state.assignment.assignment?.difficulty_level,
    prerequisites: state => state.assignment.assignment?.prerequisites || [],
    willLearn: state => state.assignment.assignment?.will_learn || [],
    sampleSubmissions: state => state.assignment.assignment?.sample_submissions || [],
    sendReasoningToStudents: state => state.assignment.assignment?.send_explainability_feedback,
    showUnitTestTips: state => state.assignment.assignment?.llm_ut_explanation,
    dispenserOn: state => state.assignment.assignment?.dispenser_on,
    feedbackPhilosophy: state => state.assignment.assignment?.philosophy_text,
}

export default assignmentSelectors
